import { createSelector } from 'reselect';
import { ACHIEVEMENTS_REDUCER_KEY } from './achievementsReducer';

export const getResourceStore = (state) => state[ACHIEVEMENTS_REDUCER_KEY];
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getAchievementsById = (state) => getResourceStore(state)?.resourcesById;
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;

export const getAchievementsBySortId = createSelector(getAchievementsById, (achievements) =>
  achievements
    ?.toList()
    .sortBy((a) => Number(a.sortId))
    .filter((achievement) => achievement?.state === 'ACTIVE'),
);

// note - there is an issue with AchievementId right now - should be fixed later
export const getAchievementById = createSelector(
  getAchievementsById,
  (_, props) => props.id,
  (achievements, id) => achievements?.get(id.toString()),
);
